<template>
  <b-card
    header="FIFO"
    header-bg-variant="Light"
    border-variant="Light"
    align="center">
    <b-card-text @click="goTo('/andon/'+item.kanban_id)">
      <b>{{displayRef(item.kanban_id)}}</b>
        -
      {{item.andon.andon_scan.kanban_card.kanban_reference.reference ? "--" : item.andon.andon_scan.kanban_card.kanban_reference.reference.supermarket_emplacement}}
      <b-badge pill variant="danger" v-if="item.andon.base.severity == 'high'">CRITIQUE</b-badge><br/>
      <b-badge pill variant="danger">{{displayDelay(item.andon.andon_scan.created_at)}} J</b-badge>
      <br />
      Vu <b-badge variant="info">{{item.andon.andon_scan.kanban_card.card_id}}</b-badge>
      <b-badge pill variant="secondary">{{item.andon.andon_scan.kanban_card.card_index}}/{{item.andon.andon_scan.kanban_card.kanban_reference.nbr_card}}</b-badge>
      <br />
      Préc. <b-badge variant="info">{{item.andon.previous_scan.kanban_card.card_id}}</b-badge>
      <b-badge pill variant="secondary">{{item.andon.previous_scan.kanban_card.card_index}}/{{item.andon.andon_scan.kanban_card.kanban_reference.nbr_card}}</b-badge>
      <br />
      <b-badge variant="dark">{{stepList[item.andon.andon_scan.workstation.name]['display']}}</b-badge>

    </b-card-text>
    <b-button v-if="isUserAdmin()" size="sm" variant="danger" @click="stopCardAndon()"><i class="fa fa-trash" aria-hidden="true"></i></b-button>
  </b-card>
</template>
<script>

import server from '../../api/server.vue'
import {Steps} from '../../core/services/steps.js'
import moment from 'moment'


export default {
  name: 'FifoCard',
  props: ['item'],
  data() {
    return {
      stepList: Steps
    };
  },
  methods: {
    displayDelay (since) {
      var now = moment()
      return now.diff(moment(since), 'days');
    },
    stopCardAndon () {
      server.stopSpecificAndon(this.item.andon.base_id).then(() => {
        this.$emit('andon-stopped')
      })
    },
    getIsAdmin() {
      return window.localStorage.getItem('isAdmin') === 'ADMIN'
    },
    displayRef(reference) {
      return this.chunk(reference, 3)
    }
  }
};
</script>

<style scoped>
  .card {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/andon/FifoCard.vue